import {
  paymentKindOf,
  type FinancialStatus,
  type OrderWithDetails,
} from "@estelle/domain";

import { formatMoney } from "@/components/table/cells";

const FINANCIAL_WORD: Record<FinancialStatus, string> = {
  pending: "Payment pending",
  authorized: "Authorized",
  partially_paid: "Partly paid",
  paid: "Paid",
  partially_refunded: "Partly refunded",
  refunded: "Refunded",
  voided: "Voided",
};

/**
 * The order page's Payment fact (#644): for a COD order not yet paid, how
 * much to collect, in red; otherwise that nothing is owed.
 */
export function paymentFact(
  order: Pick<
    OrderWithDetails,
    "paymentGatewayKey" | "financialStatus" | "total" | "totalOutstanding"
  >,
): { headline: string; tone: "collect" | "settled"; detail: string | null } {
  const isCod = paymentKindOf(order.paymentGatewayKey) === "cod";
  const outstanding = Number(order.totalOutstanding);
  if (isCod && order.financialStatus !== "paid") {
    const due = outstanding > 0 ? order.totalOutstanding : order.total;
    return {
      headline: `Collect ${formatMoney(due)}`,
      tone: "collect",
      detail: "Cash on delivery",
    };
  }
  return {
    headline: order.financialStatus
      ? FINANCIAL_WORD[order.financialStatus]
      : "Paid",
    tone: "settled",
    detail: isCod ? "Cash on delivery" : "Prepaid",
  };
}
